import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../../../../../../../hooks/store-hooks";
import { useListaCidadesService } from "../../../../../../../../../use-cases/geo-veles";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { theme } from "../../../../../../../../styles";

function RenderActualCidades(props: ListChildComponentProps) {
  const { index, style } = props;
  const { listaCidades } = useAppSelector((state) => state);

  let cidadesArray: string[] = [];

  if (
    listaCidades.editListaCidadesForm.fields.cidades &&
    Array.isArray(listaCidades.editListaCidadesForm.fields.cidades) &&
    listaCidades.editListaCidadesForm.fields.cidades.length > 0
  ) {
    cidadesArray = listaCidades.editListaCidadesForm.fields.cidades;
  } else if (listaCidades.selectedCidadeList?.Cidades) {
    try {
      const cidadesData = JSON.parse(
        listaCidades.selectedCidadeList.Cidades as unknown as string,
      );

      if (Array.isArray(cidadesData) && cidadesData.length > 0) {
        if (cidadesData[0].Nome && cidadesData[0].UF) {
          cidadesArray = cidadesData.map((cidade: any) =>
            `${cidade.Nome}/${cidade.UF}`.toLowerCase(),
          );
        } else if (typeof cidadesData[0] === "string") {
          cidadesArray = cidadesData;
        }
      } else if (cidadesData.data && Array.isArray(cidadesData.data)) {
        cidadesArray = cidadesData.data.map((item: any) =>
          `${item.Cidade}/${item.Estado}`.toLowerCase(),
        );
      }
    } catch (error) {}
  }

  return (
    <ListItem
      style={style}
      key={index}
      sx={{
        textAlign: "center",
        background: props.index % 2 !== 0 ? "#f6f6f6" : "",
      }}
    >
      <ListItemText primary={cidadesArray[index] ?? ""} />
    </ListItem>
  );
}

function RenderNewCidades(props: ListChildComponentProps) {
  const { index, style } = props;
  const { listaCidades } = useAppSelector((state) => state);

  return (
    <ListItem
      style={style}
      key={index}
      sx={{
        textAlign: "center",
        background: props.index % 2 === 0 ? "#f6f6f6" : "",
      }}
    >
      <ListItemText
        primary={
          listaCidades.fileListData.fileListTableValues.fileListValidData[
            index
          ] ?? ""
        }
      />
    </ListItem>
  );
}

function RenderRepeatedCidades(props: ListChildComponentProps) {
  const { index, style } = props;
  const { listaCidades } = useAppSelector((state) => state);

  return (
    <ListItem
      style={style}
      key={index}
      sx={{
        textAlign: "center",
        background: props.index % 2 !== 0 ? "#f6f6f6" : "",
      }}
    >
      <ListItemText
        primary={
          listaCidades.fileListData.fileListTableValues.fileListRepeatedData[
            index
          ] ?? ""
        }
      />
    </ListItem>
  );
}

function RenderInvalidCidades(props: ListChildComponentProps) {
  const { index, style } = props;
  const { listaCidades } = useAppSelector((state) => state);

  return (
    <ListItem
      style={style}
      key={index}
      sx={{
        textAlign: "center",
        background: props.index % 2 === 0 ? "#f6f6f6" : "",
      }}
    >
      <ListItemText
        primary={
          listaCidades.fileListData.fileListTableValues.fileListInvalidData[
            index
          ] ?? ""
        }
      />
    </ListItem>
  );
}

export const PreviewListaCidades = () => {
  // State
  const { listaCidades } = useAppSelector((state) => state);
  // Hook
  const {
    openPreviewListaCidades,
    addFileListToListaCidades,
    openImportFileListaCidades,
  } = useListaCidadesService();

  return (
    <>
      {listaCidades.openPreviewListaCidades === true && (
        <>
          <Dialog
            fullWidth
            maxWidth={"lg"}
            open={listaCidades.openPreviewListaCidades}
            onClose={() => {
              openPreviewListaCidades(false);
            }}
          >
            <DialogTitle>
              <Typography
                fontWeight={"bold"}
                textTransform="uppercase"
                variant="h5"
                color="primary"
              >
                Pré visualização do arquivo -{" "}
                <strong>{listaCidades.fileData.name}</strong>
              </Typography>
            </DialogTitle>
            <Box px={2}>
              <Divider color={theme.palette.primary.main} />
            </Box>
            <DialogContent>
              <Grid
                container
                height={300}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  flexDirection: "row",
                  overflowY: "hidden",
                }}
              >
                <Grid item xs={12} md={3}>
                  <Typography
                    color="primary"
                    variant="h6"
                    align={"center"}
                    fontWeight={"bold"}
                  >
                    <PlaylistAddCheckIcon sx={{ width: "8%", height: "8%" }} />{" "}
                    Cidades atuais:
                  </Typography>
                  <AutoSizer>
                    {(data: any) => (
                      <FixedSizeList
                        height={data.height}
                        width={data.width}
                        itemSize={46}
                        itemCount={(() => {
                          let cidadesArray: string[] = [];

                          if (
                            listaCidades.editListaCidadesForm.fields.cidades &&
                            Array.isArray(
                              listaCidades.editListaCidadesForm.fields.cidades,
                            ) &&
                            listaCidades.editListaCidadesForm.fields.cidades
                              .length > 0
                          ) {
                            cidadesArray =
                              listaCidades.editListaCidadesForm.fields.cidades;
                          } else if (listaCidades.selectedCidadeList?.Cidades) {
                            try {
                              const cidadesData = JSON.parse(
                                listaCidades.selectedCidadeList
                                  .Cidades as unknown as string,
                              );
                              if (
                                Array.isArray(cidadesData) &&
                                cidadesData.length > 0
                              ) {
                                if (cidadesData[0].Nome && cidadesData[0].UF) {
                                  cidadesArray = cidadesData.map(
                                    (cidade: any) =>
                                      `${cidade.Nome}/${cidade.UF}`.toLowerCase(),
                                  );
                                } else if (typeof cidadesData[0] === "string") {
                                  cidadesArray = cidadesData;
                                }
                              } else if (
                                cidadesData.data &&
                                Array.isArray(cidadesData.data)
                              ) {
                                cidadesArray = cidadesData.data.map(
                                  (item: any) =>
                                    `${item.Cidade}/${item.Estado}`.toLowerCase(),
                                );
                              }
                            } catch (error) {}
                          }

                          return cidadesArray.length;
                        })()}
                        overscanCount={5}
                        style={{
                          marginTop: 3.5,
                        }}
                      >
                        {RenderActualCidades}
                      </FixedSizeList>
                    )}
                  </AutoSizer>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    color="primary"
                    variant="h6"
                    align={"center"}
                    fontWeight={"bold"}
                  >
                    <PlaylistAddIcon sx={{ width: "8%", height: "8%" }} />{" "}
                    Cidades novas:
                  </Typography>
                  <AutoSizer>
                    {(data: any) => (
                      <FixedSizeList
                        height={data.height}
                        width={data.width}
                        itemSize={46}
                        itemCount={
                          listaCidades.fileListData.fileListTableValues
                            .fileListValidData.length ?? 0
                        }
                        overscanCount={5}
                        style={{
                          marginTop: 3.5,
                        }}
                      >
                        {RenderNewCidades}
                      </FixedSizeList>
                    )}
                  </AutoSizer>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    color="primary"
                    variant="h6"
                    align={"center"}
                    fontWeight={"bold"}
                  >
                    <SyncProblemIcon sx={{ width: "8%", height: "8%" }} />{" "}
                    Cidades repetidas:
                  </Typography>
                  <AutoSizer>
                    {(data: any) => (
                      <FixedSizeList
                        height={data.height}
                        width={data.width}
                        itemSize={46}
                        itemCount={
                          listaCidades.fileListData.fileListTableValues
                            .fileListRepeatedData.length ?? 0
                        }
                        overscanCount={5}
                        style={{
                          marginTop: 3.5,
                        }}
                      >
                        {RenderRepeatedCidades}
                      </FixedSizeList>
                    )}
                  </AutoSizer>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography
                    color="primary"
                    variant="h6"
                    align={"center"}
                    fontWeight={"bold"}
                  >
                    <PlaylistRemoveIcon sx={{ width: "8%", height: "8%" }} />{" "}
                    Cidades inválidas:
                  </Typography>
                  <AutoSizer>
                    {(data: any) => (
                      <FixedSizeList
                        height={data.height}
                        width={data.width}
                        itemSize={46}
                        itemCount={
                          listaCidades.fileListData.fileListTableValues
                            .fileListInvalidData.length ?? 0
                        }
                        overscanCount={5}
                        style={{
                          marginTop: 3.5,
                        }}
                      >
                        {RenderInvalidCidades}
                      </FixedSizeList>
                    )}
                  </AutoSizer>
                </Grid>
              </Grid>
            </DialogContent>
            <Box px={2}>
              <Divider color={theme.palette.primary.main} />
            </Box>
            <DialogActions>
              <Button
                onClick={() => {
                  openPreviewListaCidades(false);
                }}
              >
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  addFileListToListaCidades();
                  openPreviewListaCidades(false);
                  openImportFileListaCidades(false);
                }}
              >
                Enviar
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};
